import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { useSCIMStatus } from 'api/configurations';
import ConfigurationStatusCard from 'components/home/ConfigurationsStatus/ConfigurationStatusCards/ConfigurationStatusCard';
import DisabledModeTooltip from 'components/shared/DisabeldModeToolTip';
import { ROUTES } from 'constants/routes';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import React, { useCallback } from 'react';
import { useNav, useStepNavigate } from 'utils/navigation';
import AddCta from './AddCta';
import ConfiguredMark from './ConfiguredMark';

const SCIMConfigurationStatusCard: React.FC = () => {
	const { navigateToScimStep } = useStepNavigate();
	const nav = useNav();
	const { isSubTenant } = useIdPConfigContext();

	const { data: scimStatusData, isLoading } = useSCIMStatus();

	const handleClick = useCallback(() => {
		/* istanbul ignore if: no need to test this */
		if (isLoading || isSubTenant) {
			return;
		}

		if (scimStatusData?.idp && scimStatusData?.method) {
			navigateToScimStep(1, scimStatusData.idp.id, scimStatusData.method);
			return;
		}

		nav(ROUTES.selectScim);
	}, [isLoading, nav, navigateToScimStep, scimStatusData, isSubTenant]);

	return (
		<DisabledModeTooltip
			title={intl.tr('general.guide.disabledTooltip')}
			placement="right"
			disabled={isSubTenant}
		>
			<ConfigurationStatusCard
				idp={scimStatusData?.idp}
				onClick={handleClick}
				disabled={isLoading || isSubTenant}
				icon={<SyncAltIcon fontSize="large" />}
				title={intl.tr('general.SCIMConfiguration')}
				testIdTopic="scim"
				footerContent={
					scimStatusData?.scimConfigured ? <ConfiguredMark /> : <AddCta />
				}
			/>
		</DisabledModeTooltip>
	);
};

export default SCIMConfigurationStatusCard;
